module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.button-add{\r\n    text-align: center;\r\n}\r\n\r\n.wrapper{overflow: hidden;}\r\n\r\nspan{\r\n    font-weight: 700;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-form/departmental-exam-details-form.component.css
// module id = ./src/app/hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-form/departmental-exam-details-form.component.css
// module chunks = main